export default __webpack_public_path__ + "static/media/luana_lelis.6d84ddb8.png";